module.exports = __webpack_public_path__ + "img/Miladnieuw.59dbe44d.jpg";